<template>
  <div>
    <!--     
      <div class="lines-history global-page linear-gradient">
        <div v-for="index in 5"
          :key="index"
          class="infoPage">
        </div>
      </div> 
    -->
    <div id="background-home"></div>

    <v-container class="second-content">



       <v-row no-gutters>

        <v-col lg="6" md="6" sm="12" cols="12" class="pa-5 mb-5 quadre-padding">
          <div class="quadre-producte" :style="styleObject">
            
            <recicle class="iconeco" />

            <h2 class="pb-2 mb-5">
              {{ name }}
            </h2>

              <div class="double-up">
                <!--
                  <v-icon class="producte-icon"
                    data-aos="flip-right"
                    data-aos-duration="1000"
                    data-aos-delay="400">
                    mdi-nature-people
                  </v-icon>
                -->
              </div>
              
              <p v-html="text"> </p>
            
            <!-- <Tecnica /> -->
          </div>
        
        </v-col>

        <v-col lg="6" md="6" sm="12" cols="12" class="text-center pt-5">


            <v-carousel
              cycle
              height="400"
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item
                v-for="(img, i) in image"
                :key="i"
              >
                <v-sheet
                  height="100%"
                >
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center"
                  >
                    <div class="display-3">
                      <img class="image-producte" :src="require('../../../src/assets/images/products/'+`${img.src}`)" :alt="img.src" :title="img.src">
                    </div>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>


        </v-col>
       </v-row>

        <v-row class="no-gutters">
          <div class="filters">
            <submenu-ecoproductes />
          </div>
        </v-row>

      <v-row>
        <v-col>

          <div class="quadre-final">
            <div class="baseicon">
              <v-icon class="producte-icon"
                data-aos="flip-down"
                data-aos-duration="1000"
                data-aos-delay="200">
                mdi-recycle-variant
              </v-icon>
            </div>

            {{ $t('fraseFinalEcoproductes') }}

          </div>

        </v-col>
        <!--  
          <h3>
            Descripció tècnica
          </h3>
          <descripcio-tecnica />
           -->
       </v-row>
      <div class="finalPage"></div>
    </v-container>

  </div>
</template>

<script>

// import DescripcioTecnica from '@/components/elements/DescripcioTecnica.vue'
import Recicle from '@/assets/svg/Recicle.vue'
import SubmenuEcoproductes from '@/components/menu/submenu/SubmenuEcoproductes.vue'

export default {
  name: 'EcoproductesChild',
  metaInfo() {
    return { 
      metaInfo: {
        title: this.name + this.$t('ecoproductesMetaTitle'),
      },
      title: this.name + " - Packet Grup - " + this.$t('ecoproductesMetaTitle'),
      description: this.$t('ecoproductesMetaTitle'),
    }
  },
  components: {/* 
    politicaPrivacidad, */
   // DescripcioTecnica,
    Recicle,
    SubmenuEcoproductes
  },
  props: [
    'name',
    'image',
    'text'
  ],
  computed: {
    menu () {
      return this.$store.state.menu
    },
    rutas () {
      return this.$router.options.routes;
    },
    styleObject() {
      return {
        "border-color": 'rgb(192, 234, 180)',
      }
    }
  }
}

</script>

<style scoped lang="scss">

  h2 {
    border-color: #688f5c;
  }

  h3 {
    font-family: 'Cabin', sans-serif;
    color: #000;
    font-weight: normal;
    border-bottom: 2px solid #2f2f2f;
    margin: 15px 15px 0;
  }

  .producte-icon {
    color: #6cc54e !important;
    border: 5px solid #96d083;
  }

  .quadrev {

    .double {
      &-up {
          display: flex;

          i {
            margin: 0 0px 20px;
            color: #5bac40;
          }
      }
      &-down {
          display: flex;
          text-align: center;
          justify-content: center;
          width: 100%;

          i {
            font-size: 80px;
            margin: 20px 30px 0;
            color: #5bac40;
          }
      }
    }
  }



</style>
